import Rover from '@rover/globals/Rover';

import StaticStickitView from './static_stickit_view';

const COL_HEADINGS = {
  'overnight-boarding': 'How many dogs?',
  'doggy-day-care': 'How many dogs?',
  'dog-walking': 'How many walks per day?',
  'drop-in': 'How many visits per day?',
};

export default StaticStickitView.extend({
  // A view for selecting the spaces-required
  // The view takes a Query as its model.
  units: {
    'overnight-boarding': 'dog',
    'doggy-day-care': 'dog',
    'dog-walking': 'walk',
    'drop-in': 'visit',
  },

  bindings: {
    '.js-spaces-required-button': 'spaces_required',
    '.js-spaces-required-heading': {
      observe: 'service_type',
      onGet(value) {
        return this.getHeading(value);
      },
    },
    '.js-spaces-required-1-text': {
      observe: 'service_type',
      onGet(value) {
        return `1 ${this.units[value]}`;
      },
    },
    '.js-spaces-required-2-text': {
      observe: 'service_type',
      onGet(value) {
        return `2 ${this.units[value]}s`;
      },
    },
    '.js-spaces-required-3-text': {
      observe: 'service_type',
      onGet(value) {
        return `3+ ${this.units[value]}s`;
      },
    },
  },
  initialize(options) {
    StaticStickitView.prototype.initialize.call(this, options);
    this.hasPets = options.hasPets;
    this.spacesRequiredCache = new Backbone.Model({});
    this.storeSpacesRequiredForServiceType();
    this.listenTo(
      this.model,
      'change:service_type',
      _.bind(this.setSpacesRequiredToLastValue, this)
    );
    this.listenTo(this.model, 'change:service_type', _.bind(this.updateVisibility, this));
    this.listenTo(
      this.model,
      'change:spaces_required',
      _.bind(this.storeSpacesRequiredForServiceType, this)
    );
    this.updateVisibility(this.model, this.model.get('service_type'));
  },
  render() {
    StaticStickitView.prototype.render.apply(this);
    this.$el.removeClass('hidden');
  },
  calculateVisibility(serviceType) {
    if (!COL_HEADINGS.hasOwnProperty(serviceType)) {
      return false;
    }
    if (this.hasPets) {
      return this.units[serviceType] !== 'dog';
    }
    return true;
  },
  updateVisibility(model, serviceType) {
    const shouldBeVisible = this.calculateVisibility(serviceType);
    if (shouldBeVisible) {
      this.$el.removeClass('hidden');
    } else {
      this.$el.addClass('hidden');
    }
    Rover.pubSub.trigger('basic_filters:visibility_updated');
  },
  setSpacesRequiredToLastValue(model, value) {
    this.model.set('spaces_required', this.spacesRequiredCache.get(model.get('service_type')));
  },
  storeSpacesRequiredForServiceType(model, value) {
    let self = this,
      targets = this.getCacheTargets(this.model.get('service_type'));
    _.each(targets, target => {
      self.spacesRequiredCache.set(target, value);
    });
  },
  getCacheTargets(serviceType) {
    if (serviceType === 'overnight-boarding' || serviceType === 'doggy-day-care') {
      return ['overnight-boarding', 'doggy-day-care'];
    }
    return [serviceType];
  },
  getHeading(serviceType) {
    return COL_HEADINGS[serviceType];
  },
});



// WEBPACK FOOTER //
// ./js/backbone/views/spaces_required_view.js